import * as React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import * as Stripe from '../../stripe';
import './Stripe.less';
import { addTokenToAccount, fetchStripeConnectAccount, resetStripeConnectAccount } from '../stripe-connect';
import { functionsURL } from '../../firebase';
import {
  paypalTokenRequestAction,
  ConnectedPaypalButton,
  // getMerchantIdAction,
  getSellerStatusAction,
  // fetchAllPaypalConnectAccountsRequest,
  disconnectPaypalAccountRequestAction
  // updateStatusConnectPaypalAccount
} from '../paypal-connect';
import Message from '../Dialog/Message';
// import OnboardingSteps from "../Steps";
const styles = {
  heading: {
    margin: '20px 0',
    textTransform: 'uppercase'
  }
};

interface CharityProfileContainerState {
  confirmDisconnect: string;
  onKeyPress: (e: { keyCode: number; }) => void;
}

class CharityProfileContainer extends React.Component<any, CharityProfileContainerState> {

  constructor(props) {
    super(props);
    this.state = {
      confirmDisconnect: '',
      onKeyPress: (e: { keyCode: number; }) => {
        if (e.keyCode === 27) {
          this.setConfirmDisconnect(null, '');
        }
      },
    };
  }

  componentWillMount() {
    const { auth, getStripeAccount } = this.props;
    getStripeAccount(auth.uid);
    document.addEventListener('keydown', this.state.onKeyPress, false);
    this.setConfirmDisconnect(null, '');
  }

  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const token = params.get('token');  // stripe token

    // PayPal partner-referral return values
    // the partner-referral API returns our trackingID as the merchantId field
    const trackingID = params && params.get('merchantId');
    const charityPayPalPayerID = params && params.get('merchantIdInPayPal');
    // TODO: extract other URL parameters returned from PayPal onboarding form:
    // - accountStatus: "BUSINESS_ACCOUNT|PERSONAL_ACCOUNT|PREMIER_ACCOUNT"
    // - permissionsGranted
    // - consentStatus
    // - isEmailConfirmed
    const {
      auth,
      addStripeTokenToAccount,
      onGetSellerStatus
    } = this.props;

    if (token) {
      addStripeTokenToAccount(token, auth.uid);
    } else if (charityPayPalPayerID) {
    // If the seller returns to donaco.co, get seller status from seller_merchant_id in URL
      onGetSellerStatus(charityPayPalPayerID, trackingID);
    }
  }

  componentWillReceiveProps(nextProps: any) {
    if (this.props.paypal.is_connect !== nextProps.paypal.is_connect) {
      this.props.history.push('/payments');
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.state.onKeyPress, false);
    this.props.clearStripeAccount();
  }

  onDisconnectPaypal = () => {
    this.props.onDisconnectPaypalAccount();
  }

  setConfirmDisconnect(e: any, mode: '' | 'stripe' | 'paypal') {
    if (e) {
      e.preventDefault();
    }
    this.setState({
      confirmDisconnect: mode,
    });
  }

  render() {
    const { auth, stripe, classes, paypal } = this.props;
    const is_fetching_stripe = typeof (stripe.account) === 'undefined';
    const stripe_access_token = stripe.account && stripe.account.accessToken;
    const { is_fetching } = paypal;
    const paypalAccount = paypal.accounts && paypal.accounts[auth.uid];
    const is_connect = paypalAccount && paypalAccount.is_connect;

    const confirmStripeDisconnect = this.state.confirmDisconnect === 'stripe';
    const confirmPayPalDisconnect = this.state.confirmDisconnect === 'paypal';

    const stripeDisconnectURL = confirmStripeDisconnect ? `${functionsURL}/disconnect-stripe-account?uid=${auth.uid}` : null;
    const stripeConnectOnboardingURL = `${Stripe.CONNECT_ONBOARDING_URL}&redirect_uri=${
      Stripe.OAUTH_CALLBACK_URL
    }&?state=${
      auth.uid
    }&stripe_user[${
      auth.email
    }]`;

    const stripe_button_text = stripe_access_token
      ? (confirmStripeDisconnect ? 'Confirm disconnect' : 'Disconnect from Stripe')
      : 'Connect with Stripe';

    return (
      <div>
        <div className={classes.heading}>
          <Typography variant="display1">Payment accounts</Typography>
        </div>
        {this.props.paypal.error && (
          <Message Message={this.props.paypal.error} type="error" />
        )}
        <div
          className={
            "box stripe-box " +
            (stripe_access_token ? "task-completed-box" : "")
          }
        >
            <div className="wrap-content">
              <div className={'wrap-button-stripe' + (confirmStripeDisconnect ? ' confirm' : '')}>
                <a
                  href={stripe_access_token ? stripeDisconnectURL : stripeConnectOnboardingURL}
                  onClick={(stripe_access_token && !confirmStripeDisconnect) ? e => this.setConfirmDisconnect(e, 'stripe') : null}
                  className="stripe-connect btn btn-primary"
                  style={is_fetching_stripe ? {visibility: 'hidden'} : {}}
                >
                  <span>{stripe_button_text}</span>
                </a>
              {stripe && stripe.account &&
                <div
                  style={{
                    maxWidth: '260px',
                    fontSize: '.8em',
                    marginTop: '.4em',
                  }}
                ><span style={{ fontWeight: 'bold' }}>{`Account ID: ${stripe.account.stripeUserId}`}</span>
                </div>
              }
              </div>
              <div>
                <ConnectedPaypalButton
                  auth={auth}
                  account={paypalAccount}
                  is_connect={is_connect}
                  onDisconnectPaypal={this.onDisconnectPaypal}
                  isLoading={is_fetching}
                  confirm={confirmPayPalDisconnect}
                  setConfirmDisconnect={(e, m) => this.setConfirmDisconnect(e, m)}
                />
              {paypalAccount &&
                <div
                  style={{
                    maxWidth: '248px',
                    fontSize: '.8em',
                    marginTop: '.4em',
                  }}
                ><span style={{fontWeight: 'bold'}}>{`Merchant ID: ${paypalAccount.merchant_id}`}</span>
                </div>
              }
              {confirmPayPalDisconnect &&
                <div style={{ fontWeight: 'bold', fontSize: '.8em', maxWidth: '250px', padding: '1em 0' }}>
                  Disconnecting your PayPal account will remove PayPal as a payment method for donations.
              </div>}
              {paypalAccount && !paypalAccount.primary_email_confirmed && !confirmPayPalDisconnect &&
                <div
                    style={{
                      maxWidth: '248px',
                      fontSize: '.8em',
                      marginTop: '.4em',
                    }}
                ><span>Important: payments to your account may be held until you have confirmed your email address with PayPal.</span>
                </div>
              }
              </div>
            </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth, stripe, paypal }) => ({
  auth,
  stripe,
  paypal
});
const mapDispatchToProps = dispatch => ({
  getStripeAccount: (uid) => dispatch(fetchStripeConnectAccount(uid)),
  clearStripeAccount: () => dispatch(resetStripeConnectAccount()),
  addStripeTokenToAccount: (token: string, authId: string) => dispatch(addTokenToAccount(token, authId)),
  // onGetMerchantId: (tracking_id: string) => dispatch(getMerchantIdAction(tracking_id)),
  onGetSellerStatus: (merchant_id: string, tracking_id: string) => dispatch(getSellerStatusAction({merchant_id, tracking_id})),
  // onFetchAllPaypayAccounts: () => dispatch(fetchAllPaypalConnectAccountsRequest()),
  onDisconnectPaypalAccount: () => dispatch(disconnectPaypalAccountRequestAction())
});

const CharityProfile = withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CharityProfileContainer)
);

export { CharityProfile };
